import axios from 'axios';
import { buildApiV2Url, jsonApiFieldList } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';
import { mapSurveyFromJsonApiModel } from './dataMapper/surveyDataMapper';
import { TEMPLATE_TYPE_COLLECTION_PATH } from './config/EntityCollectionPathMap';

export default (entityId, extraParams = {}) =>
  axios
    .get(
      buildApiV2Url(`${TEMPLATE_TYPE_COLLECTION_PATH}/${entityId}`, {
        ...jsonApiFieldList.survey,
        ...extraParams,
      }),
    )
    .catch(generateApiError())
    .then(response => mapSurveyFromJsonApiModel(response.data));
